// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3nSWT","error":"Textarea_error__cwSEe","readonly":"Textarea_readonly__S_qg7","disabled":"Textarea_disabled__W2WIC"};